// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NyoBSII3CzGNxw {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-150, 12px);
  overflow: hidden;
  background: var(--ds-surface, #ffffff);
}
.NyoBSII3CzGNxw:not(:empty) {
  padding: var(--ds-space-050, 4px) var(--ds-space-200, 16px) var(--ds-space-100, 8px);
}
.NyoBSII3CzGNxw > * {
  overflow: hidden;
  transition: border-radius 0.2s ease-in-out;
  border-radius: var(--ds-border-radius-400, 16px);
}
.IjVedIzBNz4S7P {
  transition: padding 0.2s ease-in-out;
}
`, ""]);
// Exports
export var splitScreenBanners = `NyoBSII3CzGNxw`;
export var bannersTransition = `IjVedIzBNz4S7P`;
export default ___CSS_LOADER_EXPORT___;
